import {fetchUserInfoByUserId} from '../api';
import {getUserLoginInfo} from '../utils';

export async function getUsernameByUserid(userId) {
  const userInfo = getUserLoginInfo();
  const response = await fetchUserInfoByUserId(userId, userInfo.token);
  if (response.data && response.data.errorCode === 0) {
    return response.data.data.name || userId;
  }
  return userId;
}

export async function getUserDetailInfoByUserid(userId) {
  const loginInfo = getUserLoginInfo();
  const response = await fetchUserInfoByUserId(userId, loginInfo.token);
  if (response.data && response.data.errorCode === 0) {
    return {
      name: response.data.data.name || userId,
      avatar: response.data.data.avatar,
      userId: userId
    };
  }
  return {
    name: userId,
    avatar: '',
    userId: userId
  };
}
